export const asUnReadEnvelope = {
  data: `<svg width="14" height="12" viewBox="0 0 14 12" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.6673 1.99984C13.6673 1.2665 13.0673 0.666504 12.334 0.666504H1.66732C0.933984 0.666504 0.333984 1.2665 0.333984 1.99984V9.99984C0.333984 10.7332 0.933984 11.3332 1.66732 11.3332H12.334C13.0673 11.3332 13.6673 10.7332 13.6673 9.99984V1.99984ZM12.334 1.99984L7.00065 5.33317L1.66732 1.99984H12.334ZM12.334 9.99984H1.66732V3.33317L7.00065 6.6665L12.334 3.33317V9.99984Z" />
  </svg>`,
  name: 'unReadEnvelope',
};
